import Rollbar from 'rollbar';
import { rollbarConfig } from './rollbar.constants';

export function rollbarFactory() {
  return new Rollbar(rollbarConfig);
}
